import { UserPlus, BookOpen, Settings } from 'lucide-react';
import { Link } from 'react-router-dom';

interface SidebarFooterProps {
  collapsed: boolean;
}

/**
 * Phase 8 §3 G sidebar footer.
 *
 * Three bottom links: Invite team · Knowledge hub · Account settings.
 * The old Agent quick-toggle lives in the topbar now (§3 K). The collapse
 * chevron moved to the sidebar's top-right row (§3 B). User profile menu lives
 * in TopbarAccountMenu.
 */
export function SidebarFooter({ collapsed }: SidebarFooterProps) {
  if (collapsed) {
    // Collapsed state: no footer chrome. Icon rail in Sidebar renders the
    // flat nav; Settings sits at the bottom of that rail.
    return null;
  }

  const docsUrl = (import.meta.env.VITE_DOCS_URL as string | undefined) || '#';

  const linkClass =
    'flex h-[30px] w-full items-center gap-2 rounded-[8px] px-2 text-[13px] font-medium transition-colors vscode-text-secondary hover:vscode-bg-hover hover:vscode-text-primary';

  return (
    <div className="flex-shrink-0 px-3 pb-3 pt-1 border-t border-[color-mix(in_srgb,var(--vscode-border-primary)_40%,transparent)]">
      <Link to="/settings/team?invite=1" className={linkClass}>
        <UserPlus className="h-4 w-4 flex-shrink-0" aria-hidden />
        <span className="truncate">Invite team</span>
      </Link>
      <a
        href={docsUrl}
        target={docsUrl === '#' ? undefined : '_blank'}
        rel={docsUrl === '#' ? undefined : 'noopener noreferrer'}
        className={linkClass}
      >
        <BookOpen className="h-4 w-4 flex-shrink-0" aria-hidden />
        <span className="truncate">Knowledge hub</span>
      </a>
      <Link to="/settings/profile" className={linkClass}>
        <Settings className="h-4 w-4 flex-shrink-0" aria-hidden />
        <span className="truncate">Account settings</span>
      </Link>
    </div>
  );
}
